/*
  Elite Fanstore - « Quel maillot est fait pour toi ? » (assets/quiz-maillot.js).
  Le questionnaire de la bulle (sections/ai-questionnaire.liquid), posé dans la home : mêmes questions,
  mêmes règles de sélection, mêmes 7 langues. Seuls l'habillage et l'emplacement changent.

  - Données (arbre, équipes, textes) : assets/quiz-maillot-data.js, GÉNÉRÉ depuis le questionnaire par
    Connection/deploy-quiz-maillot.mjs. Chargé seulement quand la section approche de l'écran.
  - Quels produits pour quelles réponses : moteur commun avec la bulle, assets/elite-quiz-index.js (généré depuis le
    catalogue par Connection/build-quiz-index.mjs). Une réponse n'est proposée que si au moins un produit y correspond.
  - Logique des écrans : les fonctions marquées « = questionnaire » sont recopiées telles quelles ; le script de
    déploiement refuse d'envoyer ce fichier si elles ne sont plus identiques à celles de la bulle.
  - Tout est rattaché à la racine de chaque section (plusieurs instances possibles, aucun id global),
    et préfixé qm- : les classes qz-* de la bulle ont des styles globaux.
  - Cartes de résultats : même balisage que snippets/carte-maillot.liquid (assets/carte-maillot.css),
    cœur des favoris compris quand assets/elite-favoris.js est présent.
*/
(function(){
  if (window.EliteQuizMaillot) { window.EliteQuizMaillot.scan(); return; }

  /* ---------- Textes propres à la version home (fr = réglages de la section, sauf edit / err_quiz) ---------- */
  var HOME_I18N = {
    fr:{ edit:'Modifier', err_quiz:'Le quiz ne s’est pas chargé. Réessaie dans un instant.', remove:'' },
    en:{ edit:'Change', err_quiz:'The quiz didn’t load. Please try again in a moment.', button:'Choose my options', from:'From', sub_default:'Fan version', subs:['Player version','Kids version','Retro version'], perso:'Customisation available', remove:'Jersey, Shirt' },
    es:{ edit:'Cambiar', err_quiz:'El cuestionario no se ha cargado. Inténtalo de nuevo en un momento.', button:'Elegir mis opciones', from:'Desde', sub_default:'Versión aficionado', subs:['Versión jugador','Versión niño','Versión retro'], perso:'Personalización disponible', remove:'Camiseta' },
    de:{ edit:'Ändern', err_quiz:'Das Quiz konnte nicht geladen werden. Versuche es gleich noch einmal.', button:'Optionen wählen', from:'Ab', sub_default:'Fan-Version', subs:['Spieler-Version','Kinder-Version','Retro-Version'], perso:'Personalisierung möglich', remove:'Trikot' },
    it:{ edit:'Modifica', err_quiz:'Il quiz non si è caricato. Riprova tra un attimo.', button:'Scegli le opzioni', from:'Da', sub_default:'Versione tifoso', subs:['Versione giocatore','Versione bambino','Versione retro'], perso:'Personalizzazione disponibile', remove:'Maglia' },
    pt:{ edit:'Alterar', err_quiz:'O questionário não carregou. Tenta novamente daqui a pouco.', button:'Escolher as opções', from:'Desde', sub_default:'Versão adepto', subs:['Versão jogador','Versão criança','Versão retro'], perso:'Personalização disponível', remove:'Camisola, Camisa' },
    sv:{ edit:'Ändra', err_quiz:'Quizet kunde inte laddas. Försök igen om en stund.', button:'Välj alternativ', from:'Från', sub_default:'Supporterversion', subs:['Spelarversion','Barnversion','Retroversion'], perso:'Personalisering tillgänglig', remove:'Tröja' }
  };

  /* ---------- Pictogrammes au trait (pastille noire, trait jaune) ---------- */
  var P = {
    globe:'<circle cx="12" cy="12" r="8.5"/><path d="M3.5 12h17M12 3.5c2.4 2.6 3.6 5.4 3.6 8.5s-1.2 5.9-3.6 8.5c-2.4-2.6-3.6-5.4-3.6-8.5S9.6 6.1 12 3.5z"/>',
    shield:'<path d="M12 3.5 5 6.2v5.3c0 4.3 2.9 7.6 7 9 4.1-1.4 7-4.7 7-9V6.2z"/><path d="m9 12 2 2 4-4"/>',
    star:'<path d="m12 4 2.5 5.1 5.6.8-4.1 3.9 1 5.6-5-2.6-5 2.6 1-5.6-4.1-3.9 5.6-.8z"/>',
    palette:'<path d="M12 3.5a8.5 8.5 0 0 0 0 17c1.1 0 1.8-.8 1.8-1.7 0-.5-.2-.9-.5-1.2-.3-.4-.5-.8-.5-1.2 0-.9.8-1.7 1.7-1.7h2a4 4 0 0 0 4-4.1C20.5 7 16.7 3.5 12 3.5z"/><circle cx="7.8" cy="11.2" r=".9"/><circle cx="10.6" cy="7.6" r=".9"/><circle cx="15.2" cy="7.9" r=".9"/>',
    bolt:'<path d="M13 3.5 5.5 13.5H12l-1 7 7.5-10H12z"/>',
    history:'<path d="M4.6 12.8A7.5 7.5 0 1 0 6.7 6.7L4.5 9"/><path d="M4.5 4.8V9h4.2"/><path d="M12 8.2V12l2.8 1.8"/>',
    shirt:'<path d="M9 3.8 4.2 6 2.8 10.4 6 11.6V20h12v-8.4l3.2-1.2L19.8 6 15 3.8c-.4 1.3-1.6 2.2-3 2.2s-2.6-.9-3-2.2z"/>',
    gift:'<rect x="4" y="8.5" width="16" height="4" rx="1"/><path d="M5.5 12.5V20h13v-7.5M12 8.5V20"/><path d="M12 8.5C11 5.8 7.4 4.3 6.5 6.3c-.8 1.8 2.7 2.2 5.5 2.2zm0 0c1-2.7 4.6-4.2 5.5-2.2.8 1.8-2.7 2.2-5.5 2.2z"/>',
    arrow:'<path d="M4 12h15m-5-5 5 5-5 5"/>',
    back:'<path d="M20 12H5m5-5-5 5 5 5"/>',
    restart:'<path d="M4.6 12.8A7.5 7.5 0 1 0 6.7 6.7L4.5 9"/><path d="M4.5 4.8V9h4.2"/>',
    search:'<circle cx="11" cy="11" r="6.5"/><path d="m20 20-4.4-4.4"/>',
    truck:'<path d="M3 6.5h11v9H3zM14 9.5h3.8l3.2 3.2v2.8h-7z"/><circle cx="7" cy="17.6" r="1.7"/><circle cx="17.4" cy="17.6" r="1.7"/>',
    lock:'<rect x="5" y="10.5" width="14" height="10" rx="2"/><path d="M8 10.5V8a4 4 0 0 1 8 0v2.5"/>',
    down:'<path d="m6 9 6 6 6-6"/>'
  };
  function svg(name, size){
    return '<svg viewBox="0 0 24 24" width="'+(size||20)+'" height="'+(size||20)+'" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">'+(P[name]||'')+'</svg>';
  }
  var DUNNO_ICON = { popular:'star', concept:'palette', manga:'bolt', retro:'history', classic:'shirt', mystere:'gift' };

  /* ---------- Chargement paresseux des données (une fois pour toute la page) ---------- */
  var dataPromise = null;
  function loadData(src){
    if (typeof window.EliteQuizData === 'function') return Promise.resolve(window.EliteQuizData);
    if (!dataPromise) dataPromise = new Promise(function(resolve, reject){
      var s = document.createElement('script');
      s.src = src; s.async = true;
      s.onload = function(){ typeof window.EliteQuizData === 'function' ? resolve(window.EliteQuizData) : reject(new Error('data')); };
      s.onerror = function(){ dataPromise = null; reject(new Error('data')); };
      document.head.appendChild(s);
    });
    return dataPromise;
  }
  /* Moteur commun des quiz (assets/elite-quiz-index.js) : quels produits pour quelles réponses. Partagé avec la bulle. */
  function loadIndex(src){
    var Q = window.EliteQuizIndex;
    if (Q && Q.ready) return Promise.resolve(Q);
    if (!window.EliteQuizIndexLoading) window.EliteQuizIndexLoading = new Promise(function(resolve, reject){
      var s = document.createElement('script');
      s.src = src; s.async = true;
      s.onload = function(){ var X = window.EliteQuizIndex; X && X.ready ? resolve(X) : reject(new Error('index')); };
      s.onerror = function(){ window.EliteQuizIndexLoading = null; reject(new Error('index')); };
      document.head.appendChild(s);
    });
    return window.EliteQuizIndexLoading;
  }

  function scan(){ [].forEach.call(document.querySelectorAll('.quiz-maillot:not([data-qm-ready])'), prepare); }

  function prepare(root){
    root.setAttribute('data-qm-ready', '');
    var cfgEl = root.querySelector('[data-qm-config]');
    var cfg = {};
    try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
    var started = false;
    function start(){
      if (started) return; started = true;
      Promise.all([loadData(cfg.dataUrl), loadIndex(cfg.indexUrl)])
        .then(function(r){ init(root, cfg, r[0](cfg.locale), r[1]); })
        .catch(function(){ failed(root, cfg); });
    }
    var design = window.Shopify && window.Shopify.designMode;
    if (!design && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function(entries){
        if (entries.some(function(e){ return e.isIntersecting; })) { io.disconnect(); start(); }
      }, { rootMargin: '900px 0px' });
      io.observe(root);
    } else start();
  }

  function failed(root, cfg){
    var lang = String(cfg.locale || 'fr').slice(0, 2).toLowerCase();
    var H = HOME_I18N[lang] || HOME_I18N.fr;
    var body = root.querySelector('[data-qm-body]');
    if (body) body.innerHTML = '<div class="qm-empty">' + esc(H.err_quiz || HOME_I18N.fr.err_quiz) + '</div>';
    root.classList.remove('is-loading');
  }

  function esc(s){ return String(s).replace(/&/g,'&amp;').replace(/"/g,'&quot;').replace(/</g,'&lt;').replace(/>/g,'&gt;'); }

  /* =====================================================================================
     Une instance du quiz
     ===================================================================================== */
  function init(root, cfg, Q, IX){
    var DATA = Q.DATA, IMGV = Q.IMGV, LANG = Q.LANG, T = Q.T;
    var DUNNO = Q.DUNNO, OCCASIONS = Q.OCCASIONS, SPORTS = Q.SPORTS, TYPES = Q.TYPES, ICONS = Q.ICONS;
    var SPORT_DEFAULT = Q.SPORT_DEFAULT, STEPNO = Q.STEPNO;
    var STORE_ROOT = cfg.root || '';
    var HL = HOME_I18N[LANG] || HOME_I18N.fr;
    /* Textes des cartes : réglages de la section en français, traductions intégrées ailleurs */
    var C = cfg.card || {};
    var TX = LANG === 'fr' || !HOME_I18N[LANG] ? {
      button: C.button, from: C.from, sub_default: C.sub_default, perso: C.perso,
      subs: (C.subs || []).map(function(r){ return r[1]; })
    } : HL;
    function HT(k){ return HL[k] != null ? HL[k] : HOME_I18N.fr[k]; }

    var $ = function(sel){ return root.querySelector(sel); };
    var body = $('[data-qm-body]');
    var backBtn = $('[data-qm-back]');
    var restartBtn = $('[data-qm-restart]');
    var stepEl = $('[data-qm-step]');
    var segs = root.querySelectorAll('[data-qm-seg]');
    var recapEl = $('[data-qm-recap]');
    var quizEl = $('[data-qm-quiz]');
    var uid = root.id || 'qm';

    var state, hist, userMoved = false, opened = false;

    function snap(){ return JSON.parse(JSON.stringify(state)); }
    function goto(next, mut){ hist.push(snap()); if(mut) mut(); state.ui={}; state.screen=next; render(); }
    function replace(next, mut){ if(mut) mut(); state.ui={}; state.screen=next; render(); }
    function back(){ if(hist.length){ state=hist.pop(); render(); } }
    function jumpTo(screen){
      if(state.screen===screen) return;
      if(!hist.some(function(s){return s.screen===screen;})) return;
      while(hist.length){ var s=hist.pop(); if(s.screen===screen){ state=s; break; } }
      render();
    }
    function reset(){ state={ ui:{}, screen:'occasion' }; hist=[]; render(); }

    var backLabel = backBtn.querySelector('[data-qm-back-label]');
    if (backLabel) backLabel.textContent = T('back');
    restartBtn.setAttribute('aria-label', T('restart')); restartBtn.title = T('restart');
    backBtn.addEventListener('click', function(){ userMoved = true; back(); });
    restartBtn.addEventListener('click', function(){ userMoved = true; reset(); });

    function render(){
      var started = hist.length > 0;
      backBtn.hidden = !started;
      restartBtn.hidden = !started;
      root.classList.toggle('is-started', started);
      root.classList.toggle('is-results', state.screen === 'results');
      var n = state.screen === 'results' ? 6 : (STEPNO[state.screen] || 1);
      [].forEach.call(segs, function(s, i){
        s.classList.toggle('is-done', i < n - 1 || state.screen === 'results');
        s.classList.toggle('is-current', i === n - 1 && state.screen !== 'results');
      });
      stepEl.textContent = state.screen === 'results' ? T('result') : (T('step') + ' ' + n + ' / 6');
      recapEl.innerHTML = recapHtml();
      recapEl.hidden = !recapEl.innerHTML;
      var fn = SCREENS[state.screen];
      body.innerHTML = '<div class="qm-fade">' + (fn ? fn() : '') + '</div>';
      if (AFTER[state.screen]) AFTER[state.screen]();
      if (userMoved) keepInView();
    }

    /* Dans la page (pas dans un panneau) : si le haut du quiz est passé sous l'en-tête, on y remonte. */
    function keepInView(){
      var head = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 0;
      var top = quizEl.getBoundingClientRect().top;
      var smooth = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (top < head + 8) {
        try { window.scrollBy({ top: top - head - 16, behavior: smooth ? 'smooth' : 'auto' }); } catch (e) { window.scrollBy(0, top - head - 16); }
      }
      var title = body.querySelector('.qm-q__title');
      if (title && root.contains(document.activeElement)) { try { title.focus({ preventScroll: true }); } catch (e) {} }
    }

    /* ---------- récapitulatif « Tes choix » (cliquable pour revenir à une étape) ---------- */
    function recapHtml(){
      var s=state, c=[];
      function item(screen, lb){
        var clickable = hist.some(function(h){return h.screen===screen;});
        return '<li><button type="button" class="qm-recap__item'+(clickable?'':' is-static')+'" data-a="jump" data-s="'+screen+'"'
          + (clickable ? ' title="'+esc(HT('edit'))+'"' : ' tabindex="-1"') + '>'
          + '<span class="qm-recap__num" aria-hidden="true">'+(c.length+1)+'</span>'
          + '<span class="qm-recap__txt">'+esc(lb)+'</span></button></li>';
      }
      if(s.occasion){ var o=find(OCCASIONS,'k',s.occasion); if(o) c.push(item('occasion',o.lb)); }
      if(s.sport){ var sp=find(SPORTS,'k',s.sport); if(sp) c.push(item('sport',sp.lb)); }
      if(s.type && s.type.lb){ c.push(item('type',s.type.lb)); }
      if(s.natclub){ c.push(item('natclub', s.natclub==='nation'?T('chip_selection'):T('chip_club'))); }
      if(s.rugbycat){ c.push(item('natclub', s.rugbycat==='nations'?T('chip_nations'):T('chip_clubs'))); }
      if(s.zoneLabel){ c.push(item('zone', s.zoneLabel)); }
      if(s.teamLabel){ c.push(item('team', s.teamLabel)); }
      if(s.dunno){ var d=find(DUNNO,'k',s.dunno); if(d) c.push(item('dunno',d.lb)); }
      return c.join('');
    }
    function find(arr,k,v){ for(var i=0;i<arr.length;i++) if(arr[i][k]===v) return arr[i]; return null; }

    /* ---------- briques de rendu ---------- */
    function q(title, sub){
      return '<div class="qm-q"><h3 class="qm-q__title" tabindex="-1">'+title+'</h3>'
        + (sub ? '<p class="qm-q__sub">'+sub+'</p>' : '') + '</div>';
    }
    /* Choix sans photo : pastille noire + pictogramme jaune, texte à côté. */
    function rowTile(attrs, icon, em, t, s){
      return '<button type="button" class="qm-tile qm-tile--row" '+attrs+'>'
        + '<span class="qm-ico">'+(icon ? svg(icon, 21) : '<span class="qm-ico__em">'+em+'</span>')+'</span>'
        + '<span class="qm-tile__txt"><span class="qm-tile__t">'+t+'</span>'+(s?'<span class="qm-tile__s">'+s+'</span>':'')+'</span>'
        + '<span class="qm-tile__go">'+svg('arrow', 18)+'</span></button>';
    }
    /* Choix illustré par une photo (mêmes fichiers que la bulle). Photo absente (404) : repli en pastille. */
    function picTile(attrs, key, em, t, s){
      if(!key) return rowTile(attrs, '', em, t, s);
      return '<button type="button" class="qm-tile qm-tile--pic" '+attrs+' data-em="'+esc(em)+'" data-t="'+esc(t)+'" data-s="'+esc(s||'')+'">'
        + '<span class="qm-tile__pic"><img src="'+DATA.CDN+key+'.jpg'+IMGV+'" alt="" loading="lazy" width="400" height="400"></span>'
        + '<span class="qm-tile__lbl"><span class="qm-tile__txt"><span class="qm-tile__t">'+t+'</span>'+(s?'<span class="qm-tile__s">'+s+'</span>':'')+'</span>'
        + '<span class="qm-tile__go">'+svg('arrow', 18)+'</span></span></button>';
    }
    function wirePics(){
      [].forEach.call(body.querySelectorAll('.qm-tile--pic img'), function(img){
        function fail(){
          var b = img.closest('.qm-tile'); if(!b) return;
          var html = rowTile('', '', b.getAttribute('data-em')||'', b.getAttribute('data-t')||'', b.getAttribute('data-s')||'');
          var tmp = document.createElement('div'); tmp.innerHTML = html;
          b.className = 'qm-tile qm-tile--row'; b.innerHTML = tmp.firstChild.innerHTML;
          var grid = b.parentNode; if (grid && !grid.querySelector('.qm-tile--pic')) grid.className = 'qm-tiles qm-tiles--row';
        }
        img.addEventListener('error', fail);
        if(img.complete && img.naturalWidth===0) fail();
      });
    }
    /* Équipe : drapeau (nations) ou écusson (clubs), repli en texte si l'écusson manque. */
    function teamBtn(t){
      var med = '';
      if(t.f){ med = '<img class="qm-flag" src="https://flagcdn.com/w80/'+t.f+'.png" alt="" loading="lazy">'; }
      else if(t.c){ med = '<img class="qm-crest" src="'+DATA.CDN+t.c+'.png'+IMGV+'" alt="" loading="lazy">'; }
      return '<button type="button" class="qm-chip'+(med?' has-img':'')+'" data-a="team" data-h="'+t.h+'" data-l="'+esc(t.l)+'">'
        + (med ? '<span class="qm-chip__med">'+med+'</span>' : '')
        + '<span class="qm-chip__nm">'+esc(t.l)+'</span></button>';
    }
    function wireImgs(){
      var list = body.querySelector('[data-qm-teamlist]');
      if(!list) return;
      [].forEach.call(list.querySelectorAll('img.qm-crest'), function(img){
        function fail(){
          var chip = img.closest('.qm-chip'); if(chip) chip.classList.remove('has-img');
          var med = img.parentNode; if(med && med.parentNode) med.parentNode.removeChild(med);
        }
        img.addEventListener('error', fail);
        if(img.complete && img.naturalWidth===0) fail();
      });
    }
    /* Championnat / continent / conférence : logo, sinon pastille. */
    function zoneTile(z){
      return '<button type="button" class="qm-tile qm-tile--zone" data-a="zone" data-k="'+z.k+'">'
        + '<span class="qm-tile__logo">'+(z.logo ? '<img class="qm-zlogo" src="'+DATA.CDN+z.logo+'.png'+IMGV+'" alt="" loading="lazy">' : '<span class="qm-ico">'+svg('globe', 21)+'</span>')+'</span>'
        + '<span class="qm-tile__t">'+esc(z.label)+'</span></button>';
    }
    function wireZoneLogos(){
      [].forEach.call(body.querySelectorAll('img.qm-zlogo'), function(img){
        function fail(){ var box = img.parentNode; if(box) box.innerHTML = '<span class="qm-ico">'+svg('globe', 21)+'</span>'; }
        img.addEventListener('error', fail);
        if(img.complete && img.naturalWidth===0) fail();
      });
    }
    function skip(txt){ return dunnoFor().length ? '<button type="button" class="qm-skip" data-a="dunno-go">'+(txt||T('skip'))+svg('arrow', 16)+'</button>' : ''; }
    function more(action, label){ return '<button type="button" class="qm-more" data-a="'+action+'">'+label+svg('down', 16)+'</button>'; }

    /* ---------- écrans ---------- */
    var SCREENS = {};
    SCREENS.occasion = function(){
      return q(T('q_occasion'), T('q_occasion_sub'))
        + '<div class="qm-tiles qm-tiles--pic">'
        + OCCASIONS.filter(function(o){ return ok(occasionPatch(o.k)); })
            .map(function(o){ return picTile('data-a="occasion" data-v="'+o.k+'"', ICONS['occ-'+o.k], o.em, o.lb, o.sb); }).join('')
        + '</div>';
    };
    SCREENS.sport = function(){
      return q(T('q_sport'), T('q_sport_sub'))
        + '<div class="qm-tiles qm-tiles--pic">'
        + SPORTS.filter(function(s){ return ok({sport:s.k}); })
            .map(function(s){ return picTile('data-a="sport" data-v="'+s.k+'"', ICONS['sport-'+s.k], s.em, s.lb, ''); }).join('')
        + '</div>';
    };
    SCREENS.type = function(){
      /* photo par sport ET par type ; le rugby reprend la photo foot (comme la bulle) */
      var sp = state.sport==='rugby' ? 'foot' : (state.sport||'foot');
      return q(T('q_type'), '')
        + '<div class="qm-tiles qm-tiles--pic">'
        + typesFor().map(function(t){ return picTile('data-a="type" data-v="'+t.k+'"', ICONS['type-'+sp+'-'+t.k], t.em, t.lb, ''); }).join('')
        + '</div>';
    };
    SCREENS.natclub = function(){
      if(state.sport==='rugby'){
        return q(T('q_natclub_rugby'), '')
          + '<div class="qm-tiles qm-tiles--row">'
          + (ok({rugbycat:'nations'}) ? rowTile('data-a="rugbycat" data-v="nations"', 'globe', '', T('rugby_nations'), T('rugby_nations_sb')) : '')
          + (ok({rugbycat:'clubs'}) ? rowTile('data-a="rugbycat" data-v="clubs"', 'shield', '', T('rugby_clubs'), T('rugby_clubs_sb')) : '')
          + '</div><div class="qm-actions">'+skip()+'</div>';
      }
      return q(T('q_natclub'), '')
        + '<div class="qm-tiles qm-tiles--row">'
        + (ok({natclub:'nation'}) ? rowTile('data-a="natclub" data-v="nation"', 'globe', '', T('nat_nation'), T('nat_nation_sb')) : '')
        + (ok({natclub:'club'}) ? rowTile('data-a="natclub" data-v="club"', 'shield', '', T('nat_club'), T('nat_club_sb')) : '')
        + '</div><div class="qm-actions">'+skip()+'</div>';
    };
    SCREENS.zone = function(){
      if(state.sport==='nba'){
        return q(T('q_conf'), '')
          + '<div class="qm-tiles qm-tiles--zone">' + zonesFor(DATA.NBA).map(zoneTile).join('') + '</div>'
          + '<div class="qm-actions">'+skip(T('skip_zone'))+'</div>';
      }
      if(state.natclub==='nation'){
        return q(T('q_continent'), '')
          + '<div class="qm-tiles qm-tiles--zone">' + zonesFor(DATA.CONTINENTS).map(zoneTile).join('') + '</div>'
          + '<div class="qm-actions">'+skip(T('skip_zone'))+'</div>';
      }
      var valid = zonesFor(DATA.LEAGUES);
      var top = valid.filter(function(l){ return l.tier===1; });
      var showAll = state.ui.leaguesAll || !top.length;
      var ligs = showAll ? valid : top;
      var hidden = valid.length - top.length;
      return q(T('q_league'), '')
        + '<div class="qm-tiles qm-tiles--zone">' + ligs.map(zoneTile).join('') + '</div>'
        + '<div class="qm-actions">'
          + (!showAll && hidden ? more('more-leagues', T('more_leagues')+' (+'+hidden+')') : '')
          + skip(T('skip_zone'))
        + '</div>';
    };
    SCREENS.team = function(){
      var src = teamSource();
      var title = state.sport==='f1' ? T('q_team_f1')
        : ((state.natclub==='nation'||state.rugbycat==='nations') ? T('q_team_nation') : T('q_team'));
      var showAll = state.ui.teamsAll;
      var shown = showAll ? src : src.slice(0,8);
      var rest = src.length - shown.length;
      var showSearch = src.length > 6;
      return q(title, showSearch ? T('q_team_sub') : '')
        + (showSearch ? '<div class="qm-search"><label class="qm-visually-hidden" for="'+uid+'-search">'+esc(T('search_ph'))+'</label>'+svg('search', 18)
          + '<input id="'+uid+'-search" class="qm-search__input" type="search" placeholder="'+esc(T('search_ph'))+'" autocomplete="off" enterkeyhint="search"></div>' : '')
        + '<div class="qm-chips" data-qm-teamlist>' + shown.map(teamBtn).join('') + '</div>'
        + '<div class="qm-actions">'
          + (rest>0 && !showAll ? more('more-teams', T('more_teams')+' (+'+rest+')') : '')
          + skip(T('skip_zone'))
        + '</div>';
    };
    SCREENS.dunno = function(){
      return q(T('q_dunno'), T('q_dunno_sub'))
        + '<div class="qm-tiles qm-tiles--row">'
        + dunnoFor().map(function(d){ return rowTile('data-a="dunno" data-v="'+d.k+'"', DUNNO_ICON[d.k], d.em, d.lb, d.sb); }).join('')
        + '</div>';
    };
    SCREENS.results = function(){
      return '<div data-qm-results><div class="qm-loading"><span class="qm-spin" aria-hidden="true"></span>'+esc(T('loading'))+'</div></div>';
    };

    /* ---------- logique (= questionnaire) ---------- */
    /* Une réponse n'est proposée que si au moins un produit du catalogue lui correspond (moteur commun IX) */
    function withState(patch){ var o={}, k; for(k in state) o[k]=state[k]; for(k in patch) o[k]=patch[k]; return o; }
    function ok(patch){ return IX.has(withState(patch)); }
    function occasionPatch(k){
      return { occasion:k, audience: k==='enfant' ? 'kid' : (k==='bebe' ? 'bebe' : null), vibe: k==='collection' ? 'collector' : null };
    }
    function typesFor(){
      var list = state.sport==='foot' ? (state.audience==='kid' ? TYPES.footkid : TYPES.foot) : (TYPES[state.sport] || TYPES.foot);
      return list.filter(function(t){ return ok({type:t}); });
    }
    function zonesFor(list){ return list.filter(function(z){ return ok({zoneKey:z.k}); }); }
    function dunnoFor(){ return DUNNO.filter(function(d){ return ok({dunno:d.k}); }); }
    function afterType(){ return state.sport==='foot' ? 'natclub' : (state.sport==='nba' ? 'zone' : (state.sport==='f1' ? 'team' : 'natclub')); }
    function teamSource(){
      var list;
      if(state.sport==='f1') list = DATA.F1;
      else if(state.sport==='rugby') list = DATA.RUGBY[state.rugbycat==='clubs'?'clubs':'nations'];
      else if(state.sport==='nba'){ var z=find(DATA.NBA,'k',state.zoneKey); list = z?z.teams:[]; }
      else { var zl = find(state.natclub==='nation'?DATA.CONTINENTS:DATA.LEAGUES,'k',state.zoneKey); list = zl?zl.teams:[]; }
      var has = IX.teams(state);
      return list.filter(function(t){ return has[t.h]; });
    }
    function zoneObjByKey(k){
      var pool = state.sport==='nba' ? DATA.NBA : (state.natclub==='nation'?DATA.CONTINENTS:DATA.LEAGUES);
      return find(pool,'k',k);
    }

    /* ---------- clics (= questionnaire) ---------- */
    var H = {};
    H.jump = function(d){ jumpTo(d.s); };
    H.occasion = function(d){
      var v=d.v;
      if(v==='bebe'){ goto('results', function(){ state.occasion='bebe'; state.audience='bebe'; state.sport='foot'; }); return; }
      goto('sport', function(){
        state.occasion=v;
        if(v==='enfant') state.audience='kid';
        if(v==='collection') state.vibe='collector';
      });
    };
    H.sport = function(d){
      goto('type', function(){ state.sport=d.v; });
      if(typesFor().length===1){ replace(afterType(), function(){ state.type=typesFor()[0]; }); }
    };
    H.type = function(d){
      var t = find(typesFor(),'k',d.v);
      goto(afterType(), function(){ state.type=t; });
    };
    H.natclub = function(d){ goto('zone', function(){ state.natclub=d.v; }); };
    H.rugbycat = function(d){ goto('team', function(){ state.rugbycat=d.v; }); };
    H.zone = function(d){
      var z = zoneObjByKey(d.k);
      goto('team', function(){ state.zoneKey=d.k; state.zoneHandle=z.handle; state.zoneLabel=z.label; });
    };
    H.team = function(d){ goto('results', function(){ state.teamHandle=d.h; state.teamLabel=d.l; }); };
    H.dunno = function(d){ goto('results', function(){ state.dunno=d.v; }); };
    H['dunno-go'] = function(){
      var d = dunnoFor();  /* une seule envie possible (ex. basket : best-sellers) : directement les résultats */
      if(d.length===1){ goto('results', function(){ state.dunno=d[0].k; }); } else { goto('dunno'); }
    };
    H['more-leagues'] = function(){ state.ui.leaguesAll=true; render(); };
    H['more-teams'] = function(){ state.ui.teamsAll=true; render(); };

    quizEl.addEventListener('click', function(e){
      var card = e.target.closest('.md-card');
      if(card){ track('product', { h: card.getAttribute('data-ph')||'', team: state.teamLabel||state.zoneLabel||'' }); }
      var el = e.target.closest('[data-a]'); if(!el || !quizEl.contains(el)) return;
      var fn = H[el.getAttribute('data-a')];
      if(!fn) return;
      userMoved = true;
      if(!opened){ opened = true; track('open'); }
      fn(el.dataset, el);
    });
    recapEl.addEventListener('click', function(e){
      var el = e.target.closest('[data-a="jump"]'); if(!el || el.classList.contains('is-static')) return;
      userMoved = true; jumpTo(el.getAttribute('data-s'));
    });

    /* ---------- recherche d'équipe ---------- */
    var AFTER = {};
    AFTER.occasion = function(){ wirePics(); };
    AFTER.sport    = function(){ wirePics(); };
    AFTER.type     = function(){ wirePics(); };
    AFTER.zone     = function(){ wireZoneLogos(); };
    AFTER.team = function(){
      wireImgs();
      var inp = body.querySelector('.qm-search__input');
      if(!inp) return;
      inp.addEventListener('input', function(){
        var qy = inp.value.trim();
        var listEl = body.querySelector('[data-qm-teamlist]');
        if(!qy){
          var src = teamSource();
          listEl.innerHTML = (state.ui.teamsAll?src:src.slice(0,8)).map(teamBtn).join('');
          wireImgs();
          return;
        }
        var sport = state.sport;
        var wantNation = (state.natclub==='nation') ? 1 : (state.natclub==='club' ? 0 : -1);
        var has = IX.teams(withState({zoneKey:null}));  /* la recherche couvre tout le sport, pas seulement le championnat affiché */
        var res = DATA.SEARCH.filter(function(x){
          if(x.s!==sport || !has[x.h]) return false;
          if(wantNation!==-1 && sport==='foot' && x.n!==wantNation) return false;
          return norm(x.t).indexOf(norm(qy))>=0;
        }).slice(0,24);
        listEl.innerHTML = res.length
          ? res.map(function(x){ return teamBtn({l:x.t, h:x.h, f:x.f, c:x.c}); }).join('')
          : '<div class="qm-empty">'+esc(T('no_result'))+' « '+esc(inp.value)+' »</div>';
        wireImgs();
      });
      /* Pas de focus automatique sur écran tactile : le clavier masquerait la liste. */
      if (userMoved && window.matchMedia('(hover: hover) and (pointer: fine)').matches) { try{ inp.focus({ preventScroll: true }); }catch(e){} }
    };
    function norm(s){ return String(s).toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,''); }

    /* ---------- résolution + produits (= questionnaire) ---------- */
    AFTER.results = function(){ runResults(); };

    /* Collection du lien « Voir toute la collection » : la plus proche des réponses données */
    function linkHandle(){
      var s=state;
      if(s.occasion==='bebe') return 'body-de-foot-bebe';
      if(s.teamHandle && s.teamHandle.charAt(0)!=='~') return s.teamHandle;  /* « ~nom » = équipe sans collection : lien vers son championnat */
      if(s.dunno && s.dunno!=='popular'){
        if(s.sport==='foot'){ var d=find(DUNNO,'k',s.dunno); if(d) return d.h; }
        if(s.dunno==='retro' && s.sport==='rugby') return 'maillot-retro-rugby';
      }
      if(s.zoneHandle) return s.zoneHandle;
      return SPORT_DEFAULT[s.sport]||'meilleures-ventes';
    }

    function headline(){
      var s=state;
      if(s.occasion==='cadeau') return T('hl_cadeau');
      if(s.occasion==='bebe') return T('hl_bebe');
      if(s.occasion==='enfant') return T('hl_enfant');
      if(s.occasion==='collection') return T('hl_collection');
      return T('hl_default');
    }
    function subline(){
      var s=state, parts=[];
      if(s.teamLabel) parts.push(s.teamLabel);
      else if(s.zoneLabel) parts.push(s.zoneLabel);
      else if(s.dunno){ var d=find(DUNNO,'k',s.dunno); if(d) parts.push(d.lb); }
      if(s.type && s.type.k!=='maillot') parts.push(s.type.lb);
      return parts.length ? parts.join(' · ') : T('subline_default');
    }

    /* Uniquement les produits qui correspondent à toutes les réponses (aucun repli sur d'autres articles),
       fiches chargées à jour dans la langue du visiteur (/es/products/…), repli sur la langue principale */
    function runResults(){
      var primary = linkHandle();
      var box = body.querySelector('[data-qm-results]');
      IX.details(IX.list(state), STORE_ROOT, 6).then(function(picked){
        renderCards(box, picked, primary);
      }).catch(function(){
        box.innerHTML = '<div class="qm-empty">'+esc(T('err_load'))+'<br>'
          + '<a href="'+STORE_ROOT+'/collections/'+primary+'">'+T('see_collection')+' &#8594;</a></div>';
      });
    }

    function renderCards(box, list, primary){
      if(!list.length){
        box.innerHTML = '<div class="qm-empty">'+esc(T('err_empty'))+'<br>'
          + '<a href="'+STORE_ROOT+'/collections/'+primary+'">'+T('see_collection2')+' &#8594;</a></div>';
        return;
      }
      box.innerHTML =
        '<div class="qm-q qm-res__head">'
          + '<span class="qm-res__badge">'+esc(T('badge'))+'</span>'
          + '<h3 class="qm-q__title" tabindex="-1">'+esc(headline())+'</h3>'
          + '<p class="qm-q__sub">'+esc(subline())+'</p>'
        + '</div>'
        + '<ul class="qm-cards" role="list">' + list.map(cardHtml).join('') + '</ul>'
        + '<div class="qm-res__foot">'
          + '<a class="qm-more qm-more--link" href="'+STORE_ROOT+'/collections/'+primary+'">'+esc(T('see_collection'))+svg('arrow', 16)+'</a>'
          + '<button type="button" class="qm-skip" data-qm-again>'+svg('restart', 16)+esc(T('restart'))+'</button>'
          + '<span class="qm-trust">'+svg('truck', 17)+esc(T('trust_delivery'))+'</span>'
          + '<span class="qm-trust">'+svg('lock', 16)+esc(T('trust_payment'))+'</span>'
        + '</div>';
      var again = box.querySelector('[data-qm-again]');
      if (again) again.addEventListener('click', function(){ userMoved = true; reset(); });
      if (userMoved) keepInView();
      track('complete', {
        sport: state.sport||'',
        team: state.teamLabel || state.zoneLabel || (state.dunno? 'envie:'+state.dunno : ''),
        coll: primary,
        n: list.length
      });
    }

    /* ---------- carte produit : même balisage que snippets/carte-maillot.liquid ---------- */
    var removeWords = String(C.remove || '').split(',').concat(String(LANG==='fr' ? '' : (HL.remove||'')).split(','))
      .map(function(w){ return w.trim(); }).filter(Boolean);
    function shortTitle(title){
      var t = String(title||'');
      removeWords.forEach(function(w){ t = t.split(w).join(''); });
      t = t.replace(/\s{2,}/g, ' ').trim();
      return t || String(title||'');
    }
    /* Règles du sous-titre : titre + tags + handle (le handle est en français, donc les règles marchent dans toutes les langues) */
    function subtitleFor(p){
      var hay = (String(p.title||'') + ' ' + (p.tags||[]).join(' ') + ' ' + String(p.handle||'').replace(/-/g,' ')).toLowerCase();
      var rules = C.subs || [];
      for (var i=0;i<rules.length;i++){
        var m = String(rules[i][0]||'').trim().toLowerCase();
        var txt = TX.subs && TX.subs[i] ? TX.subs[i] : rules[i][1];
        if (m && txt && hay.indexOf(m) >= 0) return txt;
      }
      return TX.sub_default || '';
    }
    function showPerso(p){
      if (!TX.perso) return false;
      var tag = String(C.perso_tag||'').trim().toLowerCase();
      if (!tag) return true;
      return (p.tags||[]).some(function(t){ return String(t).toLowerCase() === tag; });
    }
    function sized(src, w){ return src + (src.indexOf('?')>=0 ? '&' : '?') + 'width=' + w; }
    function fmt(v){ var n=parseFloat(v); if(isNaN(n)) return '';
      return (LANG==='en') ? ('€'+n.toFixed(2)) : (n.toFixed(2).replace('.',',')+'&nbsp;€'); }
    function cardHtml(p){
      var imgs = p.images || [];
      var img1 = imgs[0] && imgs[0].src, img2 = C.second && imgs[1] && imgs[1].src;
      var best = null;
      (p.variants||[]).forEach(function(v){
        var pr = parseFloat(v.price); if (isNaN(pr)) return;
        if (!best || pr < best.pr) best = { pr: pr, cmp: parseFloat(v.compare_at_price) };
      });
      var cls = 'md-card md-card--shadow md-card--lift md-card--upper' + (C.cover ? ' md-card--cover' : '');
      var url = STORE_ROOT+'/products/'+p.handle;
      var srcset = function(src){ return [320,480,640,800].map(function(w){ return sized(src, w)+' '+w+'w'; }).join(', '); };
      var sizes = '(min-width: 1200px) 260px, (min-width: 750px) 30vw, 46vw';
      var title = shortTitle(p.title), sub = subtitleFor(p);
      var sale = best && best.cmp > best.pr;
      var h = '<li class="md-item"><a class="'+cls+'" href="'+url+'" data-ph="'+esc(p.handle)+'">'
        + '<div class="md-card__media'+(img2?' md-card__media--swap':'')+'">'
          + (img1 ? '<img class="md-card__image" src="'+esc(sized(img1, 640))+'" srcset="'+esc(srcset(img1))+'" sizes="'+sizes+'" alt="'+esc(p.title)+'" loading="lazy">' : '')
          + (img2 ? '<img class="md-card__image md-card__image--second" src="'+esc(sized(img2, 640))+'" srcset="'+esc(srcset(img2))+'" sizes="'+sizes+'" alt="" loading="lazy">' : '')
        + '</div>'
        + '<div class="md-card__info">'
          + '<p class="md-card__title">'+esc(title)+'</p>'
          + (sub ? '<p class="md-card__sub">'+esc(sub)+'</p>' : '')
          + (best ? '<p class="md-card__price">'+(TX.from ? '<span class="md-card__from">'+esc(TX.from)+'</span> ' : '')
              + '<span class="md-card__price-now'+(sale?' md-card__price-now--sale':'')+'">'+fmt(best.pr)+'</span>'
              + (sale ? ' <s class="md-card__price-was">'+fmt(best.cmp)+'</s>' : '') + '</p>' : '')
          + (showPerso(p) ? '<p class="md-card__perso"><span class="md-card__dot" aria-hidden="true"></span>'+esc(TX.perso)+'</p>' : '')
          + (TX.button ? '<span class="md-card__foot"><span class="md-card__button">'+esc(TX.button)+svg('arrow', 16)+'</span></span>' : '')
        + '</div></a>';
      if (C.favoris && window.eliteFavorisPret && p.id) {
        h += '<button type="button" class="ef-fav ef-fav--carte" data-ef-fav="'+p.id+'" data-ef-handle="'+esc(p.handle)+'" aria-pressed="false" aria-label="'+esc(cfg.favLabel||'')+'" title="'+esc(cfg.favLabel||'')+'">'
          + '<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" focusable="false"><path d="M12 20.3 4.4 12.9A4.9 4.9 0 0 1 11.3 6l.7.7.7-.7a4.9 4.9 0 0 1 6.9 6.9Z"/></svg></button>';
      }
      return h + '</li>';
    }

    /* ---------- statistiques : mêmes événements que la bulle, session préfixée « home- » ---------- */
    function sid(){
      try{ var k='qzh_sid', v=sessionStorage.getItem(k);
        if(!v){ v='home-'+Date.now().toString(36)+Math.random().toString(36).slice(2,8); sessionStorage.setItem(k,v); }
        return v; }catch(e){ return 'home-'; }
    }
    function track(ev, extra){
      if(!cfg.track) return;
      try{
        var p = { ev:ev, sid:sid(), loc:cfg.locale||'', t:Date.now() };
        if(extra) for(var k in extra){ p[k]=extra[k]; }
        var payload = JSON.stringify(p);
        if(navigator.sendBeacon){ navigator.sendBeacon(cfg.track, payload); }
        else { fetch(cfg.track, {method:'POST', mode:'no-cors', keepalive:true, headers:{'Content-Type':'text/plain;charset=UTF-8'}, body:payload}); }
      }catch(e){}
    }

    root.classList.remove('is-loading');
    reset();
  }

  window.EliteQuizMaillot = { scan: scan };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  document.addEventListener('shopify:section:load', scan);
})();
